import * as React from 'react';
/**
 * @hidden
 */

export var useCustomComponent = function useCustomComponent(comp // React.ReactElement<P>
) {
  return React.isValidElement(comp) ? [comp.type, comp.props] : [comp, {}];
};